import React from "react";
import styled from "styled-components";
import {
  FiDollarSign,
  FiTrendingDown,
  FiTrendingUp,
  FiHash,
} from "react-icons/fi";
import { COLORS } from "../utils/constants";
import { formatCurrency } from "../utils/helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: ${COLORS.white};
  border: 1px solid ${COLORS.gray200};
  border-radius: 12px;
  display: flex;
  gap: 16px;
  padding: 20px;
`;

const IconWrapper = styled.div`
  align-items: center;
  background: ${(props) => props.$bg};
  border-radius: 10px;
  display: flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  width: 44px;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CardLabel = styled.span`
  color: ${COLORS.gray500};
  font-size: 13px;
`;

const CardValue = styled.span`
  color: ${COLORS.gray800};
  font-size: 22px;
  font-weight: 600;

  @media (max-width: 500px) {
    font-size: 18px;
  }
`;

const CurrencyLabel = styled.span`
  color: ${COLORS.gray400};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const Dashboard = (props) => {
  const { byCurrency = [] } = props.summary;

  if (byCurrency.length === 0) {
    return (
      <Grid>
        <Card>
          <IconWrapper $bg={COLORS.primaryLight}>
            <FiDollarSign size={22} color={COLORS.primary} />
          </IconWrapper>
          <CardContent>
            <CardLabel>Current Balance</CardLabel>
            <CardValue>{formatCurrency(0)}</CardValue>
          </CardContent>
        </Card>
        <Card>
          <IconWrapper $bg={COLORS.dangerLight}>
            <FiTrendingDown size={22} color={COLORS.danger} />
          </IconWrapper>
          <CardContent>
            <CardLabel>Total Spent</CardLabel>
            <CardValue>{formatCurrency(0)}</CardValue>
          </CardContent>
        </Card>
        <Card>
          <IconWrapper $bg={COLORS.successLight}>
            <FiTrendingUp size={22} color={COLORS.success} />
          </IconWrapper>
          <CardContent>
            <CardLabel>Total Funded</CardLabel>
            <CardValue>{formatCurrency(0)}</CardValue>
          </CardContent>
        </Card>
        <Card>
          <IconWrapper $bg={COLORS.warningLight}>
            <FiHash size={22} color={COLORS.warning} />
          </IconWrapper>
          <CardContent>
            <CardLabel>Transactions</CardLabel>
            <CardValue>0</CardValue>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  return (
    <Container>
      {byCurrency.map((cur) => (
        <Grid key={cur.currency}>
          <Card>
            <IconWrapper $bg={COLORS.primaryLight}>
              <FiDollarSign size={22} color={COLORS.primary} />
            </IconWrapper>
            <CardContent>
              <CardLabel>
                Balance <CurrencyLabel>{cur.currency}</CurrencyLabel>
              </CardLabel>
              <CardValue
                style={{
                  color: cur.balance < 0 ? COLORS.danger : COLORS.gray800,
                }}
              >
                {formatCurrency(cur.balance, cur.currency)}
              </CardValue>
            </CardContent>
          </Card>
          <Card>
            <IconWrapper $bg={COLORS.dangerLight}>
              <FiTrendingDown size={22} color={COLORS.danger} />
            </IconWrapper>
            <CardContent>
              <CardLabel>
                Total Spent <CurrencyLabel>{cur.currency}</CurrencyLabel>
              </CardLabel>
              <CardValue>
                {formatCurrency(cur.totalExpenses, cur.currency)}
              </CardValue>
            </CardContent>
          </Card>
          <Card>
            <IconWrapper $bg={COLORS.successLight}>
              <FiTrendingUp size={22} color={COLORS.success} />
            </IconWrapper>
            <CardContent>
              <CardLabel>
                Total Funded <CurrencyLabel>{cur.currency}</CurrencyLabel>
              </CardLabel>
              <CardValue>
                {formatCurrency(cur.totalFunded, cur.currency)}
              </CardValue>
            </CardContent>
          </Card>
          <Card>
            <IconWrapper $bg={COLORS.warningLight}>
              <FiHash size={22} color={COLORS.warning} />
            </IconWrapper>
            <CardContent>
              <CardLabel>
                Transactions <CurrencyLabel>{cur.currency}</CurrencyLabel>
              </CardLabel>
              <CardValue>{cur.transactionCount}</CardValue>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Container>
  );
};

export default Dashboard;
